module.exports = __webpack_public_path__ + "media/images/pen_cadetblue-8d4766c0.png";